/* Kolekcja Premium – landing (motyw Gąbka). Bez zależności. */
(function () {
  if (window.__prmInit) return;
  window.__prmInit = true;

  function init(root) {
    root = root || document;
    root.querySelectorAll('.prm').forEach(function (el) { el.classList.add('is-js'); });
    root.querySelectorAll('[data-prm-products]').forEach(initProducts);
    root.querySelectorAll('[data-prm-swatches]').forEach(initSwatchGroups);
    root.querySelectorAll('.prm-card').forEach(initCard);
    initReveal(root);
  }

  /* ---------- Filtry kolekcji ---------- */
  function initProducts(sec) {
    if (sec.__prm) return; sec.__prm = true;
    var cards = [].slice.call(sec.querySelectorAll('.prm-card'));
    var tabs = [].slice.call(sec.querySelectorAll('[data-prm-cat]'));
    var chips = [].slice.call(sec.querySelectorAll('[data-prm-mat]'));
    var countEl = sec.querySelector('[data-prm-count]');
    var empty = sec.querySelector('.prm-empty');
    var state = { cat: 'all', mat: 'all' };

    function plural(n) {
      if (n === 1) return 'produkt';
      var d = n % 10, t = n % 100;
      return (d >= 2 && d <= 4 && (t < 12 || t > 14)) ? 'produkty' : 'produktów';
    }
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (state.cat === 'all' || c.dataset.cat === state.cat) &&
                 (state.mat === 'all' || c.dataset.mat === state.mat);
        c.hidden = !ok;
        if (ok) shown++;
      });
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.prmCat === state.cat ? 'true' : 'false'); });
      chips.forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.prmMat === state.mat ? 'true' : 'false'); });
      if (countEl) countEl.textContent = shown + ' ' + plural(shown);
      if (empty) empty.classList.toggle('is-visible', shown === 0);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { state.cat = t.dataset.prmCat; apply(); }); });
    chips.forEach(function (t) { t.addEventListener('click', function () { state.mat = t.dataset.prmMat; apply(); }); });

    sec.__prmSet = function (mat, cat) { state.mat = mat || 'all'; state.cat = cat || 'all'; apply(); };
    var reset = sec.querySelector('[data-prm-reset]');
    if (reset) reset.addEventListener('click', function () { sec.__prmSet('all', 'all'); });

    /* Liczniki modeli na kafelkach skór */
    document.querySelectorAll('[data-prm-matcount]').forEach(function (el) {
      var n = cards.filter(function (c) { return c.dataset.mat === el.dataset.prmMatcount; }).length;
      if (!n) return;
      var d = n % 10, t = n % 100;
      var w = n === 1 ? 'model' : ((d >= 2 && d <= 4 && (t < 12 || t > 14)) ? 'modele' : 'modeli');
      el.textContent = n + ' ' + w;
      el.hidden = false;
    });

    var qs = new URLSearchParams(location.search);
    if (qs.get('skora')) state.mat = qs.get('skora');
    if (qs.get('kategoria')) state.cat = qs.get('kategoria');
    apply();
  }

  /* Linki "Zobacz modele" z sekcji skór ustawiają filtr i przewijają do kolekcji */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-prm-goto]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    var sec = target && (target.matches('[data-prm-products]') ? target : target.querySelector('[data-prm-products]'));
    if (!sec || !sec.__prmSet) return;
    e.preventDefault();
    sec.__prmSet(a.dataset.prmGoto, 'all');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Swatche na kartach ---------- */
  function initCard(card) {
    if (card.__prm) return; card.__prm = true;
    var img = card.querySelector('.prm-card__main');
    var label = card.querySelector('.prm-sw__label');
    var links = card.querySelectorAll('[data-prm-link]');
    var btns = [].slice.call(card.querySelectorAll('.prm-sw__btn'));
    if (!btns.length) return;
    var defaultLabel = label ? label.innerHTML : '';

    function pick(b, persist) {
      if (img && b.dataset.img) {
        img.src = b.dataset.img;
        img.removeAttribute('srcset');
        card.classList.add('is-swatched');
      }
      if (label) label.innerHTML = b.dataset.label;
      if (persist) {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        links.forEach(function (l) { l.href = b.dataset.url; });
      }
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { pick(b, true); });
      b.addEventListener('mouseenter', function () { pick(b, false); });
      b.addEventListener('focus', function () { pick(b, false); });
    });
    card.querySelector('.prm-sw').addEventListener('mouseleave', function () {
      var active = btns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0];
      if (active) { pick(active, false); }
      else if (label) { label.innerHTML = defaultLabel; }
    });
  }

  /* ---------- Zakładki wzornika ---------- */
  function initSwatchGroups(sec) {
    if (sec.__prm) return; sec.__prm = true;
    var tabs = [].slice.call(sec.querySelectorAll('[data-prm-group]'));
    var groups = [].slice.call(sec.querySelectorAll('.prm-swgroup'));
    function show(id) {
      groups.forEach(function (g) { g.hidden = g.id !== id; });
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.prmGroup === id ? 'true' : 'false'); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.prmGroup); }); });
    if (tabs[0]) show(tabs[0].dataset.prmGroup);
  }

  /* ---------- Delikatne pojawianie się ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-prm-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Edytor motywu – przeładowanie sekcji */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
